class Language {
  LS_KEY = "klarnachrichten-user-language";

  constructor() {
    // Temporarily disabled
    // this.redirect();

    if (document.querySelector("#language-select")) {
      this.initToggle();
    }
  }

  redirect() {
    if(this.isCrawler()){
      console.log("Detected crawler, not redirecting.");
      return;
    }

    const userLanguage = this.getUserLanguage();
    if (!userLanguage) {
      console.log("Unable to get user language");
      return;
    }

    const documentLanguage = document.documentElement.getAttribute("lang");

    // No redirect necessary
    if (userLanguage === documentLanguage) {
      console.log(`Current document matches user language: ${userLanguage}`);
      return;
    }

    const targetLink = document
      .querySelector(`link[rel="alternate"][hreflang="${userLanguage}"]`)
      ?.getAttribute("href");
    if (!targetLink) {
      console.log(`Missing translation in user language: ${userLanguage}`);
      return;
    }

    window.location.href = targetLink;
  }

  isCrawler(){
    // https://stackoverflow.com/a/33941034
    const botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
    const re = new RegExp(botPattern, 'i');
    return re.test(navigator.userAgent);
  }

  getUserLanguage() {
    // Get from local storage
    const savedLanguage = localStorage.getItem(this.LS_KEY);
    if (savedLanguage) {
      return savedLanguage;
    }

    // Get browser language
    const browserLanguage = navigator.language || navigator.userLanguage;
    if (browserLanguage) {
      return browserLanguage.substring(0, 2);
    }

    return null;
  }

  initToggle() {
    this.root = document.querySelector("#language-select");
    this.overlay = document.querySelector("#language-select-overlay");
    this.toggle = document.querySelector("#language-select-toggle");
    this.isOpen = false;

    // Display select
    this.toggle.addEventListener("click", () => {
      this.isOpen ? this.close() : this.open();
    });

    // Close select if tabbed out
    this.root.querySelectorAll("a, button").forEach((el) => {
      el.addEventListener("blur", (e) => {
        if (e.relatedTarget && !e.relatedTarget.closest("#language-select")) {
          this.close();
        }
      });
    });

    // Hide select - Escape
    document.addEventListener("keydown", (e) => {
      if (this.isOpen && e.key === "Escape") {
        this.close();
      }
    });

    // Hide select - Outside click
    document.addEventListener("click", (e) => {
      if (!this.isOpen) {
        return;
      }

      if (e.target.getAttribute("id") === "language-select-backdrop") {
        this.close();
        return;
      }

      if (!e.target.closest("#language-select")) {
        this.close();
      }
    });

    // Update local storage key on language switch
    this.root.querySelectorAll("a").forEach((el) => {
      el.addEventListener("click", (e) => {
        localStorage.setItem(this.LS_KEY, el.getAttribute('data-language'))
      });
    });
  }

  open() {
    document.body.style.setProperty("overflow", "hidden");
    this.overlay.removeAttribute("inert");
    this.root.classList.add("open");
    this.isOpen = true;
  }

  close() {
    document.body.style.removeProperty("overflow");
    this.overlay.setAttribute("inert", "");
    this.root.classList.remove("open");
    this.isOpen = false;
  }
}

window.klarnachrichten.Language = new Language();
